import React from 'react';
import { Link } from 'react-router-dom';

const Sidebar: React.FC = () => {
  return (
    <aside className="w-64 bg-gray-800 h-full p-4">
      <nav className="space-y-2">
        <Link to="/" className="block hover:bg-gray-700 p-2 rounded">
          Home
        </Link>
        <Link to="/users" className="block hover:bg-gray-700 p-2 rounded">
          Users
        </Link>
        <Link to="/settings" className="block hover:bg-gray-700 p-2 rounded">
          Settings
        </Link>
      </nav>
    </aside>
  );
};

export default Sidebar;
